import { useCallback } from "react";
import { useAppDispatch } from "hooks";
import { getDIPs } from "redux/slices";
import { bouncyChestApi } from "redux/apis/bouncyChest";

/**
 * Custom hook to update bouncy chest state after purchase.
 */
export const useBouncyChestActions = () => {
	const dispatch = useAppDispatch();

	const updateBouncyChestState = useCallback(() => {
		//!* Get dips after purchase to support concurrent offers
		dispatch(getDIPs());
		//!* Apply an optimistic update to prevent the user from interacting with the icon during state transitions
		// dispatch(
		// 	// eslint-disable-next-line @typescript-eslint/no-explicit-any
		// 	bouncyChestApi.util.updateQueryData("getChestState", "", (draft: any) => {
		// 		return {
		// 			...draft,
		// 			isActiveSale: false
		// 		};
		// 	})
		// );
		//!* Finally, invalidate the endpoint to retrieve the updated icon state
		dispatch(bouncyChestApi.util.invalidateTags(["bouncyChestTag"]));
	}, [dispatch]);

	return { updateBouncyChestState };
};
